import { CallType } from '@/types';

export interface CallTypeCount {
    [CallType.INBOUND]: number;
    [CallType.OUTBOUND]: number;
    [CallType.INTERNAL]: number;
}
